import { STATUSES } from "@/domain/alerts"

export const TABS_PAGE_CONTAINER_ID = "PageWithTabsTemplate"

export const KAI_TAB_KEY = "kai"

export const KAI_GUIDANCE_TAB_KEY = "kai-guidance"

export const TAB_KEYS_BY_PAGE = {
  INVENTORY: ["branch", "applications", "images", "baseImages", "sbom", "vm"],
  SBOM: ["runtime", "all"],
  ALERT: [STATUSES.OPEN, STATUSES.RESOLVED, STATUSES.IGNORED],
  SETTINGS: [
    "users",
    "scopes",
    "auth",
    "scm",
    "apikeys",
    "deploymentkeys",
    "servicekeys",
    "ci",
    "codeScanSast",
    "labels",
    KAI_TAB_KEY,
    "externalLink_settings.system-status",
    KAI_GUIDANCE_TAB_KEY
  ],
  INTEGRATION: ["connect", "configuration"],
  INCIDENTS: ["open", "dismissed"]
}
